<template>
  <v-container fluid>
    <v-row>
      <v-col cols="10" class="titleLarge d-flex align-center">
        <p class="opacity87">{{ $t('views.fuels.title') }}</p>
      </v-col>
    </v-row>
    <FuelGraphic :data="landCoverDataBuffer" />
    <!-- <FuelSliderNdvi v-if="fuels.categorized" :range="ndviRange" /> -->
    <!-- <FuelSliderGrowing v-if="fuels.categorized" :avg="growingIndexRatingAvg" /> -->
    <!-- <FuelSliderDrought v-if="fuels.categorized" :fuels="droughtRating" /> -->
  </v-container>
</template>

<script setup lang="ts">
// Components Import
import IncidentStore from '@/stores/incidentStore.ts'

import FuelGraphic from './Fuels/FuelGraphic.vue'
// import FuelSliderNdvi from "./Sliders/FuelSliderNdvi.vue"

// Store Import
const incidentStore = IncidentStore()

// Props
const props = defineProps<{ buffer: string }>()

const landCoverDataBuffer = incidentStore.getIncidentCalculations('Fuels', 'Landcover', props.buffer)
</script>

<style lang="scss" scoped>
.over88 {
  overflow-y: auto;
}
</style>
